import BaseEntity from "../../core/entity/BaseEntity";
import {
  SegmentFilterContext,
  VectorFilterLike,
  VectorSegment,
} from "./VectorSprite";

/**
 * Base class for line segment filters that are entities
 * All filters extend BaseEntity and can use timers, onTick, etc.
 */
export abstract class BaseVectorFilter
  extends BaseEntity
  implements VectorFilterLike
{
  /**
   * Apply filter effects to line segments
   * @param segments Original segments
   * @param context Filter context with time and entity data
   * @returns Modified segments
   */
  abstract apply(
    segments: VectorSegment[],
    context: SegmentFilterContext,
  ): VectorSegment[];
}

/**
 * Type for pure segment transformation functions
 */
export type ApplyFunction = (
  segments: VectorSegment[],
  context: SegmentFilterContext,
) => VectorSegment[];
